import { observer } from 'mobx-react'
import React, { useState } from 'react'
import { useStudentResumeFormStore } from '../../../store/studentresumeform.store'
import { Box, Chip, FormControl, TextField, Typography, useTheme } from '@mui/material'
import { Icons } from '../../../utils/utilities'

const MultipleValueArrayInput = observer( ( { attrIndex, attr, values, setSectionResponseJson, sectionResponseJson, attrkey, saveChanges, section } ) => {
    const StudentResumeFormStore = useStudentResumeFormStore()

    const { palette, border } = useTheme()

    const [textfieldValue, setTextfieldValue] = useState( '' )
    const handleChange = ( e ) => {
        setTextfieldValue( e.target.value )
    }

    const removeItem = ( i ) => {
        let newValues = [...values]
        newValues.splice( i, 1 )
        setSectionResponseJson( { ...sectionResponseJson, [attrkey]: [...newValues] } )
        saveChanges( section.section_title, { ...sectionResponseJson, [attrkey]: [...newValues] } )
        StudentResumeFormStore.setChangesMade( true )
    }

    const handleKeyDown = ( e ) => {
        if ( e.key === "Enter" ) {
            e.preventDefault()
            setSectionResponseJson( { ...sectionResponseJson, [attrkey]: [...values, textfieldValue] } )
            saveChanges( section.section_title, { ...sectionResponseJson, [attrkey]: [...values, textfieldValue] } )
            StudentResumeFormStore.setChangesMade( true )
            setTextfieldValue( "" )
        }
    }

    return (
        <Box marginBottom="10px" flexGrow={1} key={attrIndex}>
            <Typography variant="subtitle2" color="GrayText">{attr.entity_detail.label}</Typography>
            <Box marginTop="10px" padding="5px 0 0 5px" borderRadius="5px" border={`1px solid ${palette.borderColor}`}>
                <FormControl sx={{ flexGrow: 1 }} fullWidth>
                    <TextField size='small' value={textfieldValue} onChange={handleChange} onKeyDown={handleKeyDown} placeholder={`To add ${attr.entity_detail.label}, type and press 'Enter'`} type="text" />
                </FormControl>
                <Box paddingY="10px">
                    <Typography fontSize="12px" gutterBottom={values.length !== 0} textAlign="center" color="textDisabled">{values.length === 0 ? `No ${attr.entity_name} added Yet` : ``}</Typography>
                    {values.length > 0 && <Box display="flex" alignItems="center" gap="10px" flexWrap="wrap">
                        {values.map( ( val, i ) => (
                            <Chip key={i} label={val} size='large' deleteIcon={Icons.default.CloseIcon} onDelete={() => { removeItem( i ) }} sx={{ bgcolor: palette.contentBg, borderRadius: "5px", border: border[1], fontSize: "14px", fontWeight: "600" }} />
                        ) )}
                    </Box>}
                </Box>
            </Box>
        </Box>
    )
} )

export default MultipleValueArrayInput
